import * as React from 'react';
import { Drawer as MuiDrawer, IconButton } from '@mui/material';
import Toolbar from '@mui/material/Toolbar';

import { DoubleArrow, ErrorBoundary, ErrorBoundaryFallback } from '@components';
import { Logo } from 'components/common/ui';
import theme from 'config/theme';
import styles from './drawer.style';
import { Menu } from './Menu';
import { Footer } from './Footer';

const Drawer = ({ open, onToggle }) => {
  const drawerWidth = open
    ? theme.customValues.drawerWidth
    : theme.customValues.closedDrawerWidth;

  return (
    <MuiDrawer
      variant="permanent"
      sx={{
        ...styles.drawer(drawerWidth),
      }}
    >
      <Toolbar
        sx={{
          ...styles.toolbar(drawerWidth),
        }}
      >
        {open && <Logo />}
        <IconButton onClick={onToggle} sx={{ transition: 'none', ml: 'auto' }}>
          <DoubleArrow
            style={{
              transform: open ? 'rotate(0deg)' : 'rotate(180deg)',
              transition: 'transform 0.2s',
            }}
          />
        </IconButton>
      </Toolbar>
      <ErrorBoundary
        showErrorDetails={process.env.NODE_ENV === 'development'}
        compact
        fallback={
          <ErrorBoundaryFallback
            title="Navigation menu crashed 😵"
            description="Please try refreshing the page."
          />
        }
      >
        <Menu open={open} onCloseMenu={onToggle} />
      </ErrorBoundary>
      <ErrorBoundary
        showErrorDetails={process.env.NODE_ENV === 'development'}
        compact
        fallback={
          <ErrorBoundaryFallback
            title="Footer crashed 😵"
            description="Please try refreshing the page."
          />
        }
      >
        <Footer open={open} />
      </ErrorBoundary>
    </MuiDrawer>
  );
};

export default Drawer;
